const LOWER_CASE_WORDS = ["by", "the", "a", "an", "of", "in", "on", "at", "to", "for", "and", "or"];

const EMPTY_VALUES = ["<unknown>", "unknown", "<n/a>", "n/a", "-"];

export function sanitizeValue(str: string | null | undefined): string {
  if (!str) return "";
  const trimmed = str.trim();
  if (!trimmed) return "";
  if (EMPTY_VALUES.includes(trimmed.toLowerCase())) return "";
  return trimmed;
}

export function toTitleCase(str: string | null | undefined): string {
  if (!str) return "";
  return str
    .toLowerCase()
    .split(" ")
    .map((word, index) => {
      if (index === 0) return word.charAt(0).toUpperCase() + word.slice(1);
      if (LOWER_CASE_WORDS.includes(word)) return word;
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
}
